// custom code HV vi:sit
// Smartlook tracking for variant picker interactions using event delegation
// Sends both variant ID and title/name and triggers a new navigation snapshot to capture updated UI
// 1. Delegated change listener for all variant controls
// 2. Triggers a new pageview/navigation when the product-template section loads and on variant selection

(function() {
  // List of selectors representing variant controls
  var variantSelectors = [
    '.swatch__input',
    '.variant-swatch-button',
    '.single-option-selector',
    '.variant-picker__option-values input[type="radio"]'
  ];

  /**
   * Handle variant control change events
   */
  function handleVariantChange(e) {
    var target = e.target;
    if (!variantSelectors.some(function(sel) { return target.matches(sel); })) {
      return;
    }
    // Get variant ID
    var variantId = target.getAttribute('data-variant') || target.value;
    // Attempt to get variant title from associated label or option text
    var variantName = '';
    try {
      // For radio inputs: find label by for attribute
      var label = document.querySelector('label[for="' + target.id + '"]');
      if (label) {
        variantName = label.textContent.trim();
      } else if (target.tagName.toLowerCase() === 'select') {
        variantName = target.options[target.selectedIndex].text;
      }
    } catch (err) {
      // ignore extraction errors
    }

    if (window.smartlook) {
      // Fire custom event
      window.smartlook('track', 'Variant Selected', { id: variantId, name: variantName });
      // Trigger navigation snapshot to capture updated UI
      var url = window.location.href.split('?')[0] + '?variant=' + variantId;
      window.smartlook('navigation', url);
    }
  }

  // Delegated listener for change events
  document.addEventListener('change', handleVariantChange, true);

  /**
   * Handle Shopify section reloads to trigger pageviews
   */
  function onSectionLoad(e) {
    if (e.detail.sectionId === 'product-template') {
      if (window.smartlook) {
        window.smartlook('trackPageView');
      }
    }
  }
  document.addEventListener('shopify:section:load', onSectionLoad);

  // Initial pageview on DOMContentLoaded
  document.addEventListener('DOMContentLoaded', function() {
    if (window.smartlook) {
      window.smartlook('trackPageView');
    }
  });
})();
